export enum ReferenceDataSearchType {
  Administration = 'Administration',
  Dossier = 'Dossier'
}
